export const housing_report_bot = [
  {
    id: 1,
    name: 'Baseline Evaluation of Informal Settlements targeted for upgrading in the 2019-2024 MTSF',
    summary: 'shortsummary/BASELINE EVALUATION OF IS TARGETED FOR UPGRADE_REPORT 28-01-20221.html',
    link: 'BASELINE EVALUATION OF IS TARGETED FOR UPGRADE.pdf',
    audio_en: 'audio/en/BASELINE EVALUATION OF IS TARGETED FOR UPGRADE_en.mp3',
    audio_af: 'audio/af/BASELINE EVALUATION OF IS TARGETED FOR UPGRADE_af.mp3',
    audio_xh: 'audio/xh/BASELINE EVALUATION OF IS TARGETED FOR UPGRADE_xh.mp3'
  },
  {
    id: 2,
    name: 'DEP Human Settlements Annual Report 2016-17',
    summary: 'shortsummary/DEP Human Settlements Annual Report 2016-17.html',
    link: 'DEP Human Settlements Annual Report 2016-17.pdf',
    audio_en: 'audio/en/DEP_Human_Settlements_Annual_Report_2016-17_en.mp3',
    audio_af: 'audio/af/DEP_Human_Settlements_Annual_Report_2016-17_af.mp3',
    audio_xh: 'audio/xh/DEP_Human_Settlements_Annual_Report_2016-17_xh.mp3'
  },
  {
    id: 3,
    name: 'Human Settlement AR2024 Website',
    summary: 'shortsummary/Human Setllement AR2024.html',
    link: 'Human Setllement AR2024 Website.pdf',
    audio_en: 'audio/en/Human_Setllement_AR2024_Website_en.mp3',
    audio_af: 'audio/af/Human_Setllement_AR2024_Website_af.mp3',
    audio_xh: 'audio/xh/Human_Setllement_AR2024_Website_xh.mp3'
  },
  {
    id: 4,
    name: 'Human Settlements 2016/2017 Yearbook',
    summary: 'shortsummary/HumanSettlements2017.html',
    link: 'Alternative and Sustainable Infrastructure Solutions for Human Settlements_Study_2017.pdf',
    audio_en: 'audio/en/Human_Settlements_Yearbook_2016-17_Draft_9th_May_2025_Dave_en.mp3',
    audio_af: 'audio/af/Human_Settlements_Yearbook_2016-17_Draft_9th_May_2025_Dave_af.mp3',
    audio_xh: 'audio/xh/Human_Settlements_Yearbook_2016-17_Draft_9th_May_2025_Dave_xh.mp3'
  },
  {
    id: 5,
    name: 'IDP Full Report (09-2022)',
    summary: 'shortsummary/IDP FULL REPORT-09-2022.html',
    link: 'IDP_Annual_Report.pdf',
    audio_en: 'audio/en/IDP_Annual_Report_en.mp3',
    audio_af: 'audio/af/IDP_Annual_Report_af.mp3',
    audio_xh: 'audio/xh/IDP_Annual_Report_xh.mp3'
  },
  {
    id: 6,
    name: 'Vote 33 Human Settlements AN',
    summary: 'shortsummary/Vote 33 Human Settlements_AN.html',
    link: 'Vote 33 Human Settlements.pdf',
    audio_en: 'audio/en/Vote 33 Human Settlements_en.mp3',
    audio_af: 'audio/af/Vote 33 Human Settlements_af.mp3',
    audio_xh: 'audio/xh/Vote 33 Human Settlements_xh.mp3'
  }
];